import SubLabel from "components/Atoms/Sublabel";
import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";
import HubSpotLifecycleTag from "HubSpot/HubSpotLifecycleTag";

const HubSpotCompanyList = (props: PickerListProps<server.dto.HubSpotCompany>) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListHubSpotCompanyInstruction & { page: number, perPage: number }>({
    keyword: "",

    // Dummy properties to satisfy the type
    page: 1,
    perPage: 10
  });

  return <>
    <PickerList
      instruction={instruction}
      onInstructionChange={setInstruction}
      queryKey="hubspotList"
      api={window.CoreApi.HubSpot.SearchCompanies}
      onClick={props.onItemSelected}
      getError={() => undefined}
      excludeKeys={props.excludeKeys}
      getId={c => c.id}
      renderListItem={hsCompany => <div className="flex gap">
        <div className="grow1">
          <div>{hsCompany.name}</div>
          <SubLabel><div>{[hsCompany.city, hsCompany.countryName].filter(Boolean).join(", ")}</div></SubLabel>
          {hsCompany.exCustomer && <SubLabel><div>Ex-customer</div></SubLabel>}
        </div>
        <div>
          <HubSpotLifecycleTag hsCompany={hsCompany} />
        </div>
      </div>}
    />
  </>;
};

export default HubSpotCompanyList;